<template>
  <v-card :disabled="loading" :loading="loading">
    <v-toolbar color="primary">
      <v-toolbar-title
        ><h1>{{ $t("config_year.config_year") }}</h1></v-toolbar-title
      >
    </v-toolbar>

    <v-card-text class="px-1 px-md-3 px-xl-6">
      <v-tabs v-model="level_tab">
        <v-tab v-for="(level, i) in levels" :key="i">
          <h2>
            {{ objectTranslator(level, "LEVEL_NAME") }}
          </h2>
        </v-tab>
      </v-tabs>

      <v-window v-model="level_tab" touchless>
        <v-window-item v-for="(level, i) in levels" :key="i">
          <v-card>
            <v-card-text class="px-1 px-md-3 px-xl-6">
              <v-btn
                color="success"
                @click="$refs.addEditDialog.open_add_modal(level.LEVEL_ID)"
                class="mt-3"
              >
                <v-icon>mdi-plus</v-icon>{{ $t("config.addnew") }}
              </v-btn>
              <v-table min-height="300px" class="mt-3 text-no-wrap text-center">
                <thead class="thead-config">
                  <tr>
                    <th class="text-center">
                      {{ $t("config.edit") }}
                    </th>
                    <th class="text-center">
                      {{ $t("config.delete") }}
                    </th>
                    <th class="text-center">#</th>
                    <th class="text-center">
                      {{ $t("config_year.admit_year") }}
                    </th>
                    <th class="text-center">
                      {{ $t("config_year.admit_semester") }}
                    </th>
                    <th class="text-center">
                      {{ $t("config_year.level_id") }}
                    </th>
                    <th class="text-center">
                      {{ $t("config_year.start_datetime_system") }}
                    </th>
                    <th class="text-center">
                      {{ $t("config_year.admit_date") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(year_item, index) in listFilter(
                      config_years,
                      level.LEVEL_ID,
                      'LEVEL_ID'
                    )"
                    v-bind:key="year_item.YEAR_ID"
                  >
                    <td>
                      <v-btn
                        small
                        color="warning"
                        v-on:click="
                          $refs.addEditDialog.open_edit_modal(year_item)
                        "
                      >
                        <v-icon>mdi-pencil</v-icon>{{ $t("config.edit") }}
                      </v-btn>
                    </td>
                    <td>
                      <v-btn
                        small
                        color="error"
                        @click="open_delete_modal(year_item)"
                      >
                        <v-icon>mdi-delete</v-icon>{{ $t("config.delete") }}
                      </v-btn>
                    </td>
                    <td>{{ index + 1 }}</td>
                    <td>{{ year_item.ADMIT_YEAR }}</td>
                    <td>{{ year_item.ADMIT_SEMESTER }}</td>
                    <td>
                      {{
                        year_item.LEVEL_ID === "1"
                          ? inlineTranslator({
                              th: "ปริญญาตรี",
                              en: "Undergraduate",
                            })
                          : inlineTranslator({
                              th: "บัณฑิตศึกษา",
                              en: "Graduate",
                            })
                      }}
                    </td>
                    <td
                      class="font-weight-bold text-right"
                      v-html="dt(year_item.START_DATETIME_SYSTEM, true)"
                    ></td>
                    <td
                      v-html="d(year_item.ADMIT_DATE, true)"
                      class="text-right"
                    ></td>
                  </tr>
                </tbody>
              </v-table>
            </v-card-text>
          </v-card>
        </v-window-item>
      </v-window>
    </v-card-text>

    <ConfigYearAddEditDialog
      ref="addEditDialog"
      :toggle_loading="toggle_loading"
    />

    <ConfigYearDeleteDialog
      v-model="showing_delete_modal"
      :title="$t('config_year.config_year')"
      :text="
        to_delete_item
          ? ` ${to_delete_item.ADMIT_SEMESTER}/${to_delete_item.ADMIT_YEAR}`
          : ''
      "
      :deleteFunction="delete_config_year"
    />
  </v-card>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import ConfigYearAddEditDialog from "./components/ConfigYearAddEditDialog";
import ConfigYearDeleteDialog from "./components/ConfigYearDeleteDialog";
import {
  objectTranslator,
  inlineTranslator,
  dateFromDBTranslatorFull as d,
  dateTimeFromDBTranslatorFull as dt,
} from "@/helper/translator";
import { getYearsModified } from "@/helper/dateTime";
import { getById } from "@/helper/filter";
import { listFilter } from "@/helper/filter";
import ConfigProvider from "@/services/config.provider";
// import RefProvider from "@/services/ref.provider";

// const refProvider = new RefProvider();
const configService = new ConfigProvider();
const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});

export default {
  name: "ConfigYear",

  data: () => ({
    loading: false,
    level_tab: null,
    // config_years: [],

    showing_delete_modal: false,

    to_delete_id: null,
    to_delete_item: null,

    levels: [
      {
        LEVEL_ID: "1",
        LEVEL_NAME_EN: "Undergraduate",
        LEVEL_NAME_TH: "ปริญญาตรี",
      },
      {
        LEVEL_ID: "2",
        LEVEL_NAME_EN: "Graduate (4+1, Master, Doctor)",
        LEVEL_NAME_TH: "บัณฑิตศึกษา (4+1, โท, เอก)",
      },
    ],
    // all_date_time: [],
  }),

  components: {
    ConfigYearAddEditDialog,
    ConfigYearDeleteDialog,
  },

  computed: {
    ...mapOfficerConfigFields({
      config_years: "config_years",
    }),
  },

  methods: {
    d,
    dt,
    objectTranslator,
    inlineTranslator,
    getYearsModified,
    listFilter,
    getById,

    toggle_loading(status) {
      this.loading = status;
    },

    open_delete_modal: function (item) {
      this.to_delete_id = item.YEAR_ID;
      this.to_delete_item = item;
      this.showing_delete_modal = true;
    },

    delete_config_year: async function () {
      this.loading = true;
      let response = await configService
        .deleteYear({
          year_id: this.to_delete_id,
        })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      this.showing_delete_modal = false;
      this.$store.dispatch("officerConfig/getYears");
      if (response && response.status)
        this.$toast.success(this.$t("toast.delete_successfully"));
      else this.$toast.error(this.$t("toast.cannot_delete"));
      this.loading = false;
    },
  },

  created() {
    this.$store.dispatch("officerConfig/getYears");
  },
};
</script>

<style>
th {
  letter-spacing: 1px;
}
</style>
